// src/platform/Shell.tsx: the frame homebuild's own pages on app.homebuild.ai share (layout F, owner 2026-10-26): the quote
// page (src/quote/QuoteScreen.tsx) and the sign-up confirm page (src/signup/ConfirmScreen.tsx), the same frame the site's
// /start wears. On a laptop the window splits edge to edge: a full-height navy side that stays still (the wordmark, then the
// page's own side) and the page beside it; below 1024px the side is a band across the top. Its styles are quote.css's frame
// (.qt-f, .qt-side, .qt-main) on confirm.css's tokens (.cf).
import "../styles/confirm.css";
import "../styles/quote.css";

/** homebuild's wordmark on the navy side, to the marketing site. */
export function Wordmark() {
  return (
    <a class="cf-wm" href="https://homebuild.ai/" aria-label="homebuild, home">
      <span class="cf-wm-mark" aria-hidden="true" />
      <span class="cf-wm-word">homebuild</span>
    </a>
  );
}

/**
 * One frame for every state of a page: the navy side (the wordmark, then `side` when the page has one, labelled `label`),
 * and the page in `main`. `mid` sets the page's words in the middle of their side, top to bottom as well, the way /start
 * sets its form (owner, 2026-10-26: "it looks insane pulled all the way up to the top").
 */
export function Shell(props: {
  side?: preact.ComponentChildren;
  label?: string;
  children: preact.ComponentChildren;
  screen: string;
  inert?: boolean;
  mid?: boolean;
}) {
  const Side = props.side ? "aside" : "div";
  return (
    <div class="cf qt qt-f" data-screen={props.screen}>
      <Side class="qt-side" aria-label={props.side ? props.label : undefined} inert={props.inert}>
        <Wordmark />
        {props.side}
      </Side>
      <main class={props.mid ? "qt-main qt-main-mid" : "qt-main"} id="main" tabIndex={-1}>
        {props.children}
      </main>
    </div>
  );
}
